import { useTranslation as e } from "../../../i18n.mjs";
import { executeWithConcurrencyLimit as t } from "../../../utils/execute-with-concurrency-limit.mjs";
import { areFilesDuplicate as n } from "../../../utils/are-files-duplicate.mjs";
import { generateUUID as r } from "../../../utils/generate-uuid.mjs";
import { useFileUploader as i } from "./use-file-uploader.mjs";
import { FileUploaderItemStateEnum as a } from "../types/file-uploader-item-type.mjs";
import { useState as o } from "react";
import { BadRequest as s } from "@systemeio/util";
import c from "lodash.throttle";
//#region src/modules/file-uploader/hooks/use-file-uploader-manager.ts
var l = ({ source: l, fileManagerApiType: u }) => {
	let { t: d } = e(), { createFileUploader: f } = i(u), [p, m] = o([]), h = p.filter((e) => e.state === a.Waiting), g = () => r(), _ = (e) => p.find((t) => t.uid === e), v = (e) => {
		let t = 0, r = e.filter((e) => {
			let r = p.some((t) => n(t.file, e));
			return r && t++, !r;
		});
		return m((e) => [...r.map((e) => ({
			uid: g(),
			file: e,
			state: a.Waiting
		})), ...e]), t;
	}, y = (e) => {
		m((e) => e.filter((e) => e.state !== a.Waiting)), v(e);
	}, b = (e, t) => {
		m((n) => n.map((n) => n.state === a.Waiting && n.uid === e ? {
			...n,
			file: t
		} : n));
	}, x = (e) => {
		m((t) => t.filter((t) => t.uid !== e));
	}, S = (e) => {
		let t = p.filter((e) => e.state === a.Waiting).find((t) => t.uid === e);
		t && x(t.uid);
	}, C = (e) => {
		let t = p.filter((e) => e.state === a.Uploading).find((t) => t.uid === e);
		t && (t.cancelUpload(), x(t.uid));
	}, w = async (e) => {
		let t = c(({ progress: t }) => {
			m((n) => n.map((n) => n.state === a.Uploading && n.uid === e ? {
				...n,
				progress: t
			} : n));
		}, 100), n = f(t);
		m((t) => t.map((t) => t.uid === e ? {
			uid: t.uid,
			file: t.file,
			state: a.Uploading,
			progress: n.progress.getState().progress,
			cancelUpload: n.cancelUpload
		} : t));
		let r = Error(d("file_manager.error"));
		try {
			let t = _(e)?.file;
			if (!t) throw r;
			let i = await n.upload({
				file: t,
				source: l
			});
			if (i) return m((t) => t.map((t) => t.uid === e ? {
				uid: t.uid,
				file: t.file,
				fileInfo: i,
				state: a.Uploaded
			} : t)), i;
		} catch (t) {
			let n = t instanceof Error ? t : r, i;
			throw i = n instanceof s ? n.message || n.toErrorWithViolations().getJoinedViolationMessages() || r.message : n.message || r.message, m((t) => t.map((t) => t.uid === e ? {
				uid: t.uid,
				file: t.file,
				state: a.Waiting,
				error: i
			} : t)), n;
		}
	};
	return {
		items: p,
		waitingUploadItems: h,
		waitingUploadFiles: h.map((e) => e.file),
		uploadedFiles: p.filter((e) => e.state === a.Uploaded).map((e) => e.fileInfo),
		replaceWaitingUploadFiles: y,
		addFilesToWaitingUpload: v,
		replaceFileInWaitingUploadItem: b,
		deleteWaitingUploadItem: S,
		deleteUploadingItem: C,
		startUploading: w,
		startUploadingAll: async (e = 10) => {
			let n = h.map((e) => () => w(e.uid));
			return await t(n, e);
		},
		clearAll: () => m([])
	};
};
//#endregion
export { l as useFileUploaderManager };
